import { useEffect, useState } from "react";
import { useT } from "../lang";

const T = {
  pt: {
    goto: "ir para",
    find: "encontrar",
    footer: "feito à mão · servido morno",
    nav: {
      hero: "oie", about: "sobre", skills: "experiência",
      portfolio: "trabalhos", substack: "substack", contact: "contato",
    },
  },
  en: {
    goto: "go to",
    find: "find me",
    footer: "handmade · served warm",
    nav: {
      hero: "hi", about: "about", skills: "experience",
      portfolio: "work", substack: "substack", contact: "contact",
    },
  },
};

export default function Footer({ onNavigate }) {
  const t = useT(T);
  const [time, setTime] = useState("");
  useEffect(() => {
    const update = () =>
      setTime(
        new Intl.DateTimeFormat("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
          timeZone: "America/New_York",
        }).format(new Date())
      );
    update();
    const id = setInterval(update, 30_000);
    return () => clearInterval(id);
  }, []);

  return (
    <footer
      data-testid="footer"
      className="border-t border-[color:var(--ink)] mt-10 py-12"
    >
      <div className="container-wide">
        <div className="grid grid-cols-12 gap-6 items-end">
          <div className="col-span-12 md:col-span-6">
            <div className="font-display uppercase text-3xl md:text-5xl leading-tight">
              GABRIELA FERRAZ <span className="text-brick">☺</span>
            </div>
            <div className="label mt-3">
              brooklyn, ny ·{" "}
              <span data-testid="footer-clock">{time || "--:--"}</span> · 2026
            </div>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="label mb-3">{t.goto}</div>
            <div className="flex flex-col gap-1">
              {[
                { id: "hero" },
                { id: "about" },
                { id: "skills" },
                { id: "portfolio" },
                { id: "substack" },
                { id: "contact" },
              ].map((it) => (
                <button
                  key={it.id}
                  onClick={() => onNavigate(it.id)}
                  data-testid={`footer-nav-${it.id}`}
                  className="text-left font-body text-base hover:text-brick transition-colors"
                >
                  {t.nav[it.id]}
                </button>
              ))}
            </div>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="label mb-3">{t.find}</div>
            <div className="flex flex-col gap-1">
              {[
                { k: "email", href: "mailto:hello@gabiferraz.co" },
                {
                  k: "linkedin",
                  href: "https://www.linkedin.com/in/hello-gabrielaferraz/",
                },
                { k: "phone", href: "tel:+19145005312" },
              ].map((s) => (
                <a
                  key={s.k}
                  href={s.href}
                  target={s.href.startsWith("mailto:") ? undefined : "_blank"}
                  rel="noreferrer"
                  className="font-body text-base hover:text-brick transition-colors"
                >
                  {s.k} ↗
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[color:var(--line)] flex flex-wrap justify-between gap-3 label">
          <span>© 2026 gabriela ferraz</span>
          <span>{t.footer}</span>
        </div>
      </div>
    </footer>
  );
}
